import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const slotWrapper = css`
  margin-inline-start: -8px;
`

export const lead = css`
  inline-size: ${spacing(5)};
  block-size: ${spacing(5)};
`

export const text = css`
  padding-inline-end: 0 !important;
`

export const content = css`
  block-size: ${spacing(4)};
`
